'use strict';

/**show-class="condition,class,class(optional)"
 * Condition true:
 * remove any display overwriting
 * digest (with 50ms wait)
 * add class
 * Condition false:
 * remove class
 * add second class if any
 * wait transition duration, if any (css property of the element)
 * set display: none
 * remove second class, if any
 */

angular.module('v6CoreModule').directive('showClass', () => ({
  link: function (scope, element, attrs) {
    const values = attrs.showClass.split(',');
    let timer;
    let i;

    scope.$watch(values[0], (nv, ov) => {
      if (nv) {
        /*so not on the first page initialization*/
        $(element).css('display', '');
        if (timer) {
          clearTimeout(timer);
        }
        //scope.$digest();
        setTimeout(() => {
          $(element).addClass(values[1]);
        }, 50);
      }
      if (nv === false) {
        let delay = $(element).css('transition-duration');
        if (delay) {
          i = delay.indexOf('ms');
          if (i > -1) {
            delay = delay.substr(0, i);
            delay = parseInt(delay);
          } else {
            i = delay.indexOf('s');
            if (i > -1) {
              delay = delay.substr(0, i);
              delay = parseInt(delay) * 1000;
            } else {
              delay = 0;
            }
          }
        } else {
          delay = 0;
        }
        //add second class for alternative transition away. Remove that class when display is set to none.
        $(element).removeClass(values[1]);
        if (values[2]) {
          $(element).addClass(values[2]);
        }
        timer = setTimeout(() => {
          $(element).css('display', 'none');
          if (values[2]) {
            $(element.removeClass(values[2]));
          }
        }, delay);
      }
    });
  },
}));
